export default "__VITE_ASSET__C8Wu2mYR__"